type AnyObject = Record<any, string | undefined | null>;

export function justMergeSimilar<T extends AnyObject, T2 extends AnyObject>(
  one: T,
  two: T2,
): T & T2 {
  const entryOne = Object.entries(one).reduce((acc, entry) => {
    const [key, value] = entry;
    acc[key] = [value ?? '', two[key] ?? ''].join(' ');
    return acc;
  }, {} as AnyObject);

  return {
    ...two,
    ...entryOne,
  } as T & T2;
}
